import Person from '@linc-technologies/linced-common/models/person';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

export default class _Person extends Person {
  declare [Type]: 'person';

  // Technically a belongsTo relationship, but we don't want to auto-fetch user records.
  @attr('string')
  declare userId: string | undefined;
}
